<form [formGroup]="projectForm" (ngSubmit)="onSubmit()">
  <!-- Contact & Contract Details Panel -->
  <p-panel header="Contact & Détails du contrat" toggleable="true" styleClass="mb-3">
    <div class="grid flex-wrap gap-4">
      <!-- Contact Type -->
      <div class="col-12 md:col-6">
        <label class="block mb-1">Type de contact *</label>
        <div class="flex align-items-center gap-3">
          <p-radioButton name="typeContact" formControlName="typeContact" value="personne_physique" inputId="tcPhysique"></p-radioButton>
          <label for="tcPhysique">Personne physique</label>
          <p-radioButton name="typeContact" formControlName="typeContact" value="personne_morale" inputId="tcMorale" [disabled]="true"></p-radioButton>
          <label for="tcMorale" class="text-gray-500">Personne morale (désactivé)</label>
        </div>
      </div>

      <!-- Effective Date -->
      <div class="col-12 md:col-6">
        <label for="dateEffetSouhaitee" class="block mb-1">Date d’effet souhaitée *</label>
        <p-calendar inputId="dateEffetSouhaitee" formControlName="dateEffetSouhaitee" dateFormat="dd/mm/yy" [showIcon]="true" [minDate]="minDate" class="w-full"></p-calendar>
      </div>
    </div>
  </p-panel>

  <!-- Project Details Panel -->
  <p-panel header="Détails du projet" toggleable="true" styleClass="mb-3">
    <div class="grid flex-wrap gap-4">
      <!-- Status -->
      <div class="col-12 md:col-4">
        <label for="statut" class="block mb-1">Statut *</label>
        <p-dropdown inputId="statut" formControlName="statut" [options]="statutOptions" optionLabel="label" placeholder="Sélectionner" class="w-full"></p-dropdown>
      </div>

      <!-- Origin -->
      <div class="col-12 md:col-4">
        <label for="origine" class="block mb-1">Origine *</label>
        <p-dropdown inputId="origine" formControlName="origine" [options]="origineOptions" optionLabel="label" placeholder="Sélectionner" class="w-full"></p-dropdown>
      </div>

      <!-- APRIL Product -->
      <div class="col-12 md:col-4">
        <label for="productReference" class="block mb-1">Produit APRIL *</label>
        <p-dropdown inputId="productReference" formControlName="productReference" [options]="productOptions" optionLabel="label" placeholder="Sélectionner un produit" class="w-full"></p-dropdown>
      </div>
    </div>
  </p-panel>

  <!-- Insured Person's Details Panel -->
  <p-panel header="Coordonnées de l'assuré" toggleable="true" styleClass="mb-3">
    <div class="grid flex-wrap gap-4">
      <!-- Title -->
      <div class="col-12 md:col-2">
        <label for="civilite" class="block mb-1">Civilité *</label>
        <p-dropdown inputId="civilite" formControlName="civilite" [options]="civiliteOptions" optionLabel="label" placeholder="Sélectionner" class="w-full"></p-dropdown>
      </div>

      <!-- Last Name -->
      <div class="col-12 md:col-5">
        <label for="nom" class="block mb-1">Nom *</label>
        <input pInputText id="nom" formControlName="nom" class="w-full" placeholder="Saisir le nom" />
      </div>

      <!-- First Name -->
      <div class="col-12 md:col-5">
        <label for="prenom" class="block mb-1">Prénom *</label>
        <input pInputText id="prenom" formControlName="prenom" class="w-full" placeholder="Saisir le prénom" />
      </div>

      <!-- Birth Date -->
      <div class="col-12 md:col-4">
        <label for="dateNaissance" class="block mb-1">Date de naissance *</label>
        <p-calendar inputId="dateNaissance" formControlName="dateNaissance" dateFormat="dd/mm/yy" showIcon="true" [yearNavigator]="true" [monthNavigator]="true" yearRange="1920:2024" class="w-full"></p-calendar>
      </div>

      <!-- Marital Status -->
      <div class="col-12 md:col-4">
        <label for="etatCivil" class="block mb-1">État civil *</label>
        <p-dropdown inputId="etatCivil" formControlName="etatCivil" [options]="etatCivilOptions" optionLabel="label" placeholder="Sélectionner" class="w-full"></p-dropdown>
      </div>

      <!-- Social Security Number -->
      <div class="col-12 md:col-4">
        <label for="socialSecurityNumber" class="block mb-1">N° de Sécurité Sociale</label>
        <input pInputText id="socialSecurityNumber" formControlName="socialSecurityNumber" class="w-full" placeholder="(facultatif)" />
      </div>

      <!-- Address Type -->
      <div class="col-12">
        <label class="block mb-2">Type d'adresse *</label>
        <div class="flex flex-wrap gap-3">
          <div *ngFor="let option of addressTypeOptions" class="flex align-items-center">
            <p-radioButton 
              [name]="'addressType'" 
              [value]="option.value" 
              [formControlName]="'addressType'"
              [inputId]="'addressType_' + option.value">
            </p-radioButton>
            <label [for]="'addressType_' + option.value" class="ml-2">{{ option.label }}</label>
          </div>
        </div>
      </div>

      <!-- Address -->
      <div class="col-12">
        <label for="adresse" class="block mb-1">Adresse *</label>
        <input pInputText id="adresse" formControlName="adresse" class="w-full" placeholder="Saisir l’adresse" />
      </div>

      <!-- Postal Code -->
      <div class="col-12 md:col-4">
        <label for="codePostal" class="block mb-1">Code Postal *</label>
        <input pInputText id="codePostal" formControlName="codePostal" class="w-full" placeholder="Saisir le code postal" />
      </div>

      <!-- City -->
      <div class="col-12 md:col-4">
        <label for="ville" class="block mb-1">Ville *</label>
        <input pInputText id="ville" formControlName="ville" class="w-full" placeholder="Saisir la ville" />
      </div>

      <!-- Country -->
      <div class="col-12 md:col-4">
        <label for="pays" class="block mb-1">Pays *</label>
        <p-dropdown inputId="pays" formControlName="pays" [options]="paysOptions" optionLabel="label" placeholder="Sélectionner" class="w-full"></p-dropdown>
      </div>

      <!-- Phone -->
      <div class="col-12 md:col-6">
        <label for="telephone" class="block mb-1">Numéro de téléphone *</label>
        <input pInputMask id="telephone" formControlName="telephone" mask="99 99 99 99 99" class="w-full" placeholder="01 23 45 67 89" />
      </div>

      <!-- Email -->
      <div class="col-12 md:col-6">
        <label for="email" class="block mb-1">Email *</label>
        <input pInputText id="email" formControlName="email" class="w-full" placeholder="exemple@domaine.com" />
      </div>
    </div>
  </p-panel>

  <!-- Health Guarantees Panel -->
  <p-panel header="Garanties Santé" toggleable="true" styleClass="mb-3">
    <div class="grid flex-wrap gap-4">
      <div class="col-12 md:col-6">
        <label for="garanties" class="block mb-1">Garanties *</label>
        <p-multiSelect inputId="garanties" formControlName="garanties" [options]="garantiesOptions" optionLabel="label" placeholder="Sélectionner (plusieurs)" class="w-full"></p-multiSelect>
      </div>
    </div>
  </p-panel>

  <!-- Submission Buttons -->
  <div class="flex justify-end gap-3 mt-4">
    <button pButton type="submit" label="Valider & Lancer le comparateur" icon="pi pi-arrow-right" class="p-button-success"></button>
  </div>
</form>
